export interface PowerBiReportOption {
  reportId: string
  pageId?: string
  label: string
}

export const WORKSPACE_LABELS: Record<'CAT' | 'IFP', string> = {
  CAT: 'Category Assortment Tool',
  IFP: 'Flow Tool',
}

export interface PlanDetailFilterTarget {
  table: string
  column: string
}

export interface PlanDetailTabConfig {
  reportId: string
  pageId: string
  filterTarget: PlanDetailFilterTarget
  slicerTitle?: string
}

export const PLAN_DETAIL_TABS: Record<
  'summary' | 'financials' | 'analytics',
  PlanDetailTabConfig
> = {
  summary: {
    reportId:
      import.meta.env.VITE_PBI_SUMMARY_REPORT_ID ||
      '12fda31d-ce39-4ee0-8153-ba9ebf32eb97',
    pageId: import.meta.env.VITE_PBI_SUMMARY_PAGE_ID || '4659418bebce6e39cdc2',
    filterTarget: {
      table: 'assortment_plan_summary_measures_vw',
      column: 'assortment_plan_id',
    },
  },
  financials: {
    reportId:
      import.meta.env.VITE_PBI_FINANCIALS_REPORT_ID ||
      '12fda31d-ce39-4ee0-8153-ba9ebf32eb97',
    pageId:
      import.meta.env.VITE_PBI_FINANCIALS_PAGE_ID || '4659418bebce6e39cdc2',
    filterTarget: {
      table: 'assortment_plan_summary_to_mfp_vw',
      column: 'assortment_plan_id',
    },
  },
  analytics: {
    reportId:
      import.meta.env.VITE_PBI_ANALYTICS_REPORT_ID ||
      'a87a784d-b7ad-4ce0-8255-72ccaa9e124e',
    pageId:
      import.meta.env.VITE_PBI_ANALYTICS_PAGE_ID || '4659418bebce6e39cdc2',
    filterTarget: {
      table: 'assortment_plan_line_view',
      column: 'assortment_plan_name',
    },
    slicerTitle: 'Assortment Plan',
  },
}

export const POWERBI_REPORTS: Record<'CAT' | 'IFP', PowerBiReportOption[]> = {
  IFP: [
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_EVENT_PRODUCT_FLOW_REPORT_ID ||
        '85c7eabb-4095-4f6e-8c26-f8bf820a6a30',
      pageId:
        import.meta.env.VITE_PBI_IFP_EVENT_PRODUCT_FLOW_PAGE_ID ||
        '3f517a7936e802d337a5',
      label: 'Event Product Flow',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_COST_SHIFT_GRID_REPORT_ID ||
        'fc979f22-cdd9-4b84-87c8-db1589729890',
      label: 'Cost Shift Grid',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_PO_LEVEL_DETAIL_REPORT_ID ||
        '10e11421-e2d3-4cf1-8939-cdd022bb84cc',
      label: 'PO Level Detail View',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_STORE_CUBE_CARTON_REPORT_ID ||
        '985ad988-0dcb-4e55-9096-54276f093408',
      label: 'Store Cube Carton Update',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_INBOUND_FLOW_REPORT_ID ||
        '6d3f3d71-f0c4-4d2d-a5b7-609f3d2074ab',
      label: 'Inbound Flow Report',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_POG_ON_TIME_REPORT_ID ||
        'b6160b10-2846-445e-91f1-5daaa302fe8a',
      label: 'POG On-Time Projection',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_IFP_SEASON_EVENT_DISPOSITION_REPORT_ID ||
        '1339e61e-4ade-4096-9024-690e228faa2b',
      pageId:
        import.meta.env.VITE_PBI_IFP_SEASON_EVENT_DISPOSITION_PAGE_ID ||
        'cad2eabeed3024ca0000',
      label: 'Season Event Disposition',
    },
  ],
  CAT: [
    {
      reportId:
        import.meta.env.VITE_PBI_CAT_FINANCIALS_REPORT_ID ||
        'bae8ef13-f937-48d6-b83c-396bc5861d4b',
      pageId:
        import.meta.env.VITE_PBI_CAT_FINANCIALS_PAGE_ID ||
        '4659418bebce6e39cdc2',
      label: 'Financials',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_CAT_PARETO_REPORT_ID ||
        '75045aa0-a15d-42e1-9fc2-55c953fb90c5',
      pageId:
        import.meta.env.VITE_PBI_CAT_PARETO_PAGE_ID || '6766be5ef2241f1f1307',
      label: 'Pareto Curve',
    },
    {
      reportId:
        import.meta.env.VITE_PBI_CAT_ATTRIBUTES_REPORT_ID ||
        '4d9a1c52-2e78-4b8c-9e3d-7c41a5f1b2e6',
      pageId:
        import.meta.env.VITE_PBI_CAT_ATTRIBUTES_PAGE_ID ||
        '4659418bebce6e39cdc2',
      label: 'Attributes',
    },
  ],
}
